<template>
  <v-main>
    <v-container class="fill-height" fluid style="background-color: #ccc">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-row align="center" justify="center">
            <v-col cols="12" align="center">
              <h1 class="text-center mb-5">{{ $t('login.title') }}<br /></h1>
              <h1 class="text-center mb-5">{{ $t('login.logIn') }}<br /></h1>
              <div style="font-size: 28px"></div>
            </v-col>
          </v-row>
          <v-card class="elevation-12" v-if="!$store.getters.isAuthen || true">
            <v-card-text>
              <div align="center">
                <!-- <v-avatar size="120px"> -->
                <img height="60" :src="staticPath + 'logo_tai.jpg'" />
                <!-- <LangSelect class="set-language" /> -->
                <!-- <br/><br/> -->
                <!-- <span style="font-size:12px;color:#252525">(โดยใช้ชุดเดียวกันกับตอนล็อกอินบนเครื่องคอมพิวเตอร์ที่<br>สถาบันยานยนต์)</span> -->
                <!-- </v-avatar> -->
              </div>
              <v-form v-model="valid" ref="form" @submit.prevent>
                <v-text-field
                  dense
                  filled
                  ref="username"
                  :label="$t('login.username')"
                  prepend-inner-icon="mdi-account"
                  class="my-5"
                  hint=""
                  v-model="user.username"
                  :rules="nameRules"
                  @keyup.enter="$refs.password.focus()"
                  autofocus
                  required
                  :disabled="ok"
                ></v-text-field>
                <v-text-field
                  dense
                  filled
                  ref="password"
                  :label="$t('login.password')"
                  :prepend-inner-icon="showpass ? 'mdi-form-textbox-password' : 'mdi-lock'"
                  hint=""
                  v-model="user.password"
                  :rules="passwordRules"
                  @keyup.enter="signIn"
                  :append-icon="showpass ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showpass ? 'text' : 'password'"
                  @click:append="showpass = !showpass"
                  required
                  :disabled="ok"
                ></v-text-field>
              </v-form>
              <v-alert v-if="error !== ''" outline color="error" icon="warning" :value="true">
                {{ this.$t('login.error') }}
              </v-alert>
              <v-alert type="warning" :value="$browserDetect.isIE"> กรุณาเปิดด้วย Chrome หรือ Firefox หรือ Safari </v-alert>
            </v-card-text>
            <v-progress-linear v-bind:indeterminate="true" v-if="ok"></v-progress-linear>
            <v-card-actions>
              <v-btn block @click="signIn" :disabled="ok" :class="{ primary: valid, error: !valid }">{{ $t('login.logIn') }}</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn text @click="forgotPass" :disabled="ok" class=""> <v-icon left> mdi-lock-open-variant </v-icon>{{ $t('login.forgot') }} </v-btn>
              <v-spacer></v-spacer>
              <v-btn text class="blue--text" @click="Register">{{ $t('login.register') }}</v-btn>
            </v-card-actions>
          </v-card>

          <v-card class="mt-2" v-show="recapcharEnable">
            <v-card-actions>
              <v-spacer></v-spacer>
              <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey"> </vue-recaptcha>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <!-- <v-alert color="error" class="white--text">{{$browserDetect}}หมายเหตุ : กรุณากด Ctrl+F5 เพื่อรับ Version ใหม่ของโปรแกรม</v-alert> -->

          <br /><br />
          <div style="font-size: 14px" class="lockscreen-footer text-center">Ver:1.20.0 Build:20240307.015017</div>
          <div class="lockscreen-footer text-center">
            Copyright © 2022
            <b><a href="#" class="text-black"></a></b><br />
            All rights reserved
          </div>
          <div class="">
            {{ this.$store.state.users.main.loginCount }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { mapActions } from 'vuex'
import LangSelect from '@/components/LangSelect'
// import bookServ from '@/store/api/services/bookService'
// import browserDetect from 'vue-browser-detect-plugin'

export default {
  name: 'login',
  components: {
    VueRecaptcha,
    LangSelect
  },
  data() {
    return {
      recapcharEnable: false,
      loginCount: 0,
      sitekey: '6LfRYwAgAAAAAGvIRAzdtN823T4sdbvJLzgHj_8D',
      recapcha: 'recapcha',
      showpass: false,
      version: '1.20.0',
      apiPath: process.env.VUE_APP_API_PATH.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      staticPath: process.env.VUE_APP_STATIC.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      user: {
        username: '',
        password: '',
        version: '1.20.0'
      },
      redirect: '',
      valid: false,
      ok: false,
      error: '',
      browser: '',

      nameRules: [(v) => !!v || this.$t('login.username_error_request'), (v) => v.length >= 5 || this.$t('login.username_error_length') + ' ', (val) => this.recapcha !== '' || 'reCAPTCHA is required.' + this.recapcha],
      passwordRules: [(v) => !!v || this.$t('login.password_error_request'), (v) => v.length >= 8 || this.$t('login.password_error_length'), (val) => this.recapcha !== '' || 'reCAPTCHA is required.' + this.recapcha]
    }
  },

  mounted() {
    // browser = $browserDetect
    console.log('browser', this.browser)
    console.log('process.env', process.env)
    window.localStorage.clear()
    localStorage.setItem('isoList-pagination', '')
    localStorage.setItem('isoList-process', '')
    localStorage.setItem('isoList-filter', '')
    localStorage.setItem('vuex', '')
    localStorage.setItem('EmpAll', '')
    if (localStorage.getItem('loginCount') === null) {
      localStorage.setItem('loginCount', 0)
    }
  },
  methods: {
    ...mapActions(['customerSignIn']),
    clear() {
      this.user.username = ''
      this.user.password = ''
      this.ok = false
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.signIn()
      }
    },
    async signIn() {
      this.$refs.form.validate()
      if (this.valid) {
        this.loginCount = localStorage.getItem('loginCount')
        this.ok = true
        this.error = ''

        this.redirect = ''
        this.user.username = this.user.username.trim()
        await this.$store.dispatch('customerSignIn', this.user)
        try {
          console.log('authen', this.$store.getters)
          if (this.$store.getters.isAuthen) {
            if (this.$route.query.redirect) {
              // this.$router.push(this.$route.query.redirect)
              this.redirect = this.$route.query.redirect
            } else {
              // console.log('this.$store.state.users.main.Activated', this.$store.state.users.main.Activated)
              if (this.$store.state.users.custmain.Activated === null) {
                this.redirect = '/profile'
              } else {
                this.redirect = '/'
              }
            }
            // this.$router.push('/')
            localStorage.setItem('loginCount', 0)
            this.$router.push(this.redirect)
          } else {
            this.ok = false
            this.error = this.$t('login.error')
            this.loginCount++
            this.resetRecaptcha()
          }
        } catch (error) {
          console.log('Show error notification!', 'Something wrong')
          this.ok = false
          this.error = 'Something wrong'
          this.loginCount++
          this.resetRecaptcha()
        }
        localStorage.setItem('loginCount', this.loginCount)
        if (this.loginCount >= 3) {
          this.recapcharEnable = true
          this.recapcha = ''
        }
      }
    },
    signOut() {
      this.$store.dispatch('signOut')
      this.$router.push('/signin')
    },
    forgotPass() {
      console.log('forgotPass')
      this.$router.push('/ForgotPassword')
    },
    Register() {
      console.log('register')
      this.$router.push('/register')
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.recapcha = response
      this.$refs.form.validate()
    },
    onExpired: function () {
      console.log('Expired')
      this.recapcha = ''
      this.$refs.form.validate()
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  }
}
</script>

<style scoped>
.set-language {
  color: #fff;
  position: absolute;
  top: 3px;
  font-size: 18px;
  right: 0px;
  cursor: pointer;
}
</style>
